import React from 'react';
import { formatDateByLanguage } from "utils/dateFormatter/dateFormatter";
import type { INotificationHistory } from 'redux/notifications/reducer';
import { useTranslation } from 'react-i18next';

import { NotificationStatus } from "components/Notifications";
import { Button } from 'components/commons';
import { ReactComponent as EyeIcon } from "assets/icons/new/UI/EyeOpenCircle.svg";

interface INotification {
    notification: INotificationHistory,
    openModalHandler: (data: INotificationHistory) => void
}

const Notification: React.FC<INotification> = ({ notification, openModalHandler }) => {

    return (
        <>
        <li
            className={`relative h-10 group w-full flex gap-x-2 text-start p-2 dark:hover:text-theme-color-active hover:bg-theme-hover dark:hover:bg-theme-hover hover:text-theme-color-active`}
            onClick={() => openModalHandler(notification)}
        >
            <div className="relative shrink-0">
                <span className={`flex shrink-0 justify-center items-center size-6 bg-c-light-gray dark:bg-c-light-black border border-theme-border dark:border-theme-border text-sm font-semibold rounded-full shadow-2xs`}>
                    C
                </span>
            </div>
            <div className="grow flex items-center gap-x-2 min-w-0"> {/* Изменено здесь */}
                <div className="min-w-0 flex-1 overflow-hidden"> {/* Обертка для текста */}
                    <p className="text-xs overflow-hidden text-ellipsis whitespace-nowrap">
                        {notification.title}
                    </p>
                    <p className="text-[10px] overflow-hidden text-ellipsis whitespace-nowrap">
                        {formatDateByLanguage(new Date(notification.createdAt.replace(/-/g, "/")), "p P")}
                        <span className='text-gray-500'>#{notification.id}</span>
                    </p>
                </div>
                {notification.status && (
                    <div className="shrink-0 max-w-25"> {/* Изменено здесь */}
                        <NotificationStatus
                            status={notification.status}
                            progress={notification.progress}
                        />
                    </div>
                )}
            </div>
        </li>
        {/* <li className="border-b py-2 px-4 flex items-center justify-between border-gray-200 last:border-0 flex-wrap">
            <div
                className="block"
            >
                <div>
                    <span className="block text-sm"><span className="font-thin text-xs text-notification-gray">{notification.title}</span></span>
                    <div className="block text-sm flex items-center justify-between text-gray-400">
                        <div className="text-xs text-notification-light-gray">
                            {formatDateByLanguage(new Date(notification.createdAt.replace(/-/g, "/")), "p P")} <span className={`text-gray-300`}>#{notification.id}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex items-center cursor-pointer">
                {
                    notification.status &&
                    <NotificationStatus status={notification.status} progress={notification.progress} />
                }
                <Button clickHandler={() => openModalHandler(notification)}>
                    <EyeIcon className="stroke-[#7f7f7f] w-[17px] h-[17px]" />
                </Button>
            </div>
        </li> */}
        </>
    )
}

export default Notification